import { BaseApi, type RequestHeaders, type RequestParams, type PaginatedResponse } from '@bv/api/base';

export class WithPagination<Item extends Record<string, any> = object> extends BaseApi {
  /**
   * Creates an instance of the child class.
   * This constructor passes the endpoint to the parent class's constructor.
   * @param {string} endpoint - The API endpoint that will be passed up to the base class constructor.
   */
  public constructor(endpoint: string) {
    super(endpoint);
  }

  /**
   * Fetch paginated items
   * @param {Object} [config] - Optional configuration for the request.
   * @param {RequestParams} [config.params] - Additional query parameters to send with the request.
   * @param {RequestHeaders} [config.headers] - Custom HTTP headers to send with the request.
   * @returns {Promise<PaginatedResponse<Item>>}
   * @public
   */
  public async paginated({
    params,
    headers,
  }: {
    params?: RequestParams;
    headers?: RequestHeaders;
  } = {}): Promise<PaginatedResponse<Item>> {
    return this.request<Item, PaginatedResponse<Item>>({
      method: 'get',
      params,
      headers,
    });
  }
}
